import React from 'react'
import {KTCard, KTCardBody} from '../../../../_websoft/helpers'
import {ToastContainer} from 'react-toastify'

// IMPORTANT (once in your app, e.g. src/index.tsx or App.tsx):
// import 'bootstrap-icons/font/bootstrap-icons.css'
// and ensure: npm i bootstrap-icons

type Tile = {
    title: string
    subtitle: string
    url: string
    color: 'success' | 'info' | 'primary' | 'warning' | 'danger'
    iconClass: string // Bootstrap Icons class
    description?: string
}

const TerminaliRasjecanje = () => {
    const tiles: Tile[] = [
        {
            title: 'Rasjecanje',
            subtitle: 'Pregled zadataka',
            description: 'Trebovanje rolni za rasjecanje.',
            url: 'dashboard-rasjecanje/rasjecanje/1',
            color: 'success',
            iconClass: 'bi-scissors',
        },
        {
            title: 'Odmotavanje',
            subtitle: 'Pregled zadataka',
            description: 'Trebovanje rolni za odmotavanje.',
            url: 'dashboard-rasjecanje/odmotavanje/2',
            color: 'info',
            iconClass: 'bi-arrow-repeat',
        },
    ]

    return (
        <KTCard>
            <ToastContainer />

            <KTCardBody className='py-8'>
                {/* Header */}
                <div className='d-flex flex-wrap align-items-center justify-content-between mb-8'>
                    <div>
                        <h2 className='fw-bold mb-1'>Terminali</h2>
                        <div className='text-muted fw-semibold'>Odaberite radnu stanicu</div>
                    </div>

                    <div className='d-flex align-items-center gap-2'>
                        <span className='badge badge-light fw-semibold'>Rasjecanje / Odmotavanje modul</span>
                    </div>
                </div>

                {/* Tiles */}
                <div className='row g-6'>
                    {tiles.map((item, index) => (
                        <div key={index} className='col-md-6 col-xl-4'>
                            <a
                                href={item.url}
                                className='text-decoration-none d-block h-100'
                                aria-label={item.title}
                            >
                                <div className={`card card-xl-stretch h-100 bg-light-${item.color} hover-elevate-up shadow-sm`}>
                                    <div className='card-body p-7 d-flex align-items-center'>
                                        {/* Icon */}
                                        <div className='me-5'>
                                            <div className={`symbol symbol-60px`}>
                                                <span className={`symbol-label bg-${item.color}`}>
                                                  <i className={`bi ${item.iconClass} fs-2x text-white`} />
                                                </span>
                                            </div>
                                        </div>

                                        {/* Text */}
                                        <div className='d-flex flex-column flex-grow-1'>
                                            <div className='d-flex align-items-center gap-3'>
                                                <span className='fw-bold fs-2 text-dark text-uppercase'>{item.title}</span>
                                                <span className={`badge badge-light-${item.color} fw-semibold`}>Pregled</span>
                                            </div>

                                            <span className='text-muted fw-semibold mb-1'>{item.subtitle}</span>

                                            {item.description ? (
                                                <span className='text-gray-700 fw-normal'>{item.description}</span>
                                            ) : null}
                                        </div>

                                        {/* Arrow */}
                                        <div className='ms-4'>
                      <span className='btn btn-sm btn-icon btn-light'>
                        <i className='bi bi-arrow-right fs-4 text-gray-700' />
                      </span>
                                        </div>
                                    </div>
                                </div>
                            </a>
                        </div>
                    ))}
                </div>
            </KTCardBody>
        </KTCard>
    )
}

export default TerminaliRasjecanje
